(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ok-cursor-sparkles"] && !Shopify.designMode) return;
  try {
    const initOkCursorSparkles = () => {
    const canvas = document.querySelector('.ok-cursor-sparkles')
    if (!canvas || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
    if (window.matchMedia('(pointer: coarse)').matches) return

    const context = canvas.getContext('2d')
    if (!context) return

    // Oh Kira pink palette — blush fill, kira-pink glow
    const FILL_R = 255, FILL_G = 212, FILL_B = 224   // #ffd4e0 blush
    const GLOW_R = 255, GLOW_G = 122, GLOW_B = 160   // #ff7aa0 kira-pink

    let width = 0
    let height = 0
    let particles = []
    let lastMouseParticle = 0
    let running = false

    const resize = () => {
      const ratio = Math.min(window.devicePixelRatio || 1, 2)
      width = window.innerWidth
      height = window.innerHeight
      canvas.width = width * ratio
      canvas.height = height * ratio
      canvas.style.width = width + 'px'
      canvas.style.height = height + 'px'
      context.setTransform(ratio, 0, 0, ratio, 0, 0)
    }

    const addParticle = (x, y, ambient) => {
      if (particles.length > 72) particles.shift()

      particles.push({
        x: x + (Math.random() - 0.5) * (ambient ? 90 : 42),
        y: y + (Math.random() - 0.5) * (ambient ? 90 : 42),
        size: Math.random() * 3 + 1,
        speedX: (Math.random() - 0.5) * 0.8,
        speedY: Math.random() * 0.8 + 0.35,
        life: 1,
        decay: Math.random() * 0.018 + 0.014,
        rotation: Math.random() * Math.PI,
      })
    }

    const drawStar = (p) => {
      const radius = p.size * (p.life * 2)
      const alpha = Math.max(0, p.life)
      context.save()
      context.translate(p.x, p.y)
      context.rotate(p.rotation)
      context.beginPath()

      for (let i = 0; i < 8; i++) {
        const r = i % 2 === 0 ? radius : radius * 0.3
        const a = (i * Math.PI) / 4
        context.lineTo(r * Math.sin(a), -r * Math.cos(a))
      }

      context.closePath()
      context.fillStyle = `rgba(${FILL_R},${FILL_G},${FILL_B},${alpha})`
      context.shadowBlur = radius * 2.5
      context.shadowColor = `rgba(${GLOW_R},${GLOW_G},${GLOW_B},${alpha})`
      context.fill()
      context.restore()
    }

    const render = () => {
      context.clearRect(0, 0, width, height)

      for (let i = particles.length - 1; i >= 0; i--) {
        const p = particles[i]
        p.x += p.speedX
        p.y -= p.speedY
        p.life -= p.decay
        p.rotation += 0.02

        if (p.life <= 0) {
          particles.splice(i, 1)
        } else {
          drawStar(p)
        }
      }

      if (particles.length > 0) {
        requestAnimationFrame(render)
      } else {
        running = false
      }
    }

    const requestRender = () => {
      if (running) return
      running = true
      requestAnimationFrame(render)
    }

    resize()
    window.addEventListener('resize', resize)

    window.addEventListener('mousemove', (e) => {
      const now = performance.now()
      if (now - lastMouseParticle > 28) {
        addParticle(e.clientX, e.clientY, false)
        lastMouseParticle = now
        requestRender()
      }
    })

    if (document.querySelector('.ok-editorial-home')) {
      window.setInterval(() => {
        addParticle(Math.random() * width, Math.random() * height, true)
        requestRender()
      }, 260)
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOkCursorSparkles)
  } else {
    initOkCursorSparkles()
  }
  } catch(e) { console.error(e); }
})();

})();
